import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSectionPlane = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M20 4.4209V16.5791L10 21L0 16.5791V4.4209L10 0L20 4.4209ZM2 5.72266V15.2764L10 18.8125L18 15.2764V5.72266L10 2.18652L2 5.72266Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3867 5.92285L11 9.43457V19H9V9.43457L0.613281 5.92285L1.38672 4.07715L10 7.68457L18.6133 4.07715L19.3867 5.92285Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 9L2 5V16L10 19V9Z",
			fill: "currentColor"
		})
	]
});
export default SvgSectionPlane;
